var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-blank',[_c('div',{staticClass:"lang-select d-flex"},[_c('app-bar-theme-switcher'),(_vm.isLoggedIn)?_c('app-bar-notification'):_vm._e(),_c('app-bar-i18n')],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }